class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      let delval = this.getAttribute('data-producthandle');
      $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/cart.js',
        success: function (cart) {
          let newqty = 0;
          cart.items.forEach(function (item) {
            let itemvarid = item.sku;
            if (itemvarid == delval && item.price == 0) {
              newqty = item.id;
            }
          });
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
              id: newqty,
              quantity: 0
            },
            dataType: "json",
            success: function (e) {
              location.reload();
            }
          });
        }
      });

    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, thi) {
    this.enableLoading(line);

    // Set flag to prevent price contamination during cart operations
    window.cartOperationInProgress = true;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        // Override Upcart's cart icon after a short delay
        setTimeout(() => {
          this.forceCorrectCartIcon();
        }, 100);

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        // if(parsedState.item_count != cart.item_count){
        //             location.reload();
        //           }

        const thus = this.querySelector(`.cart-item:nth-child(${line})`);
        // console.log(thus);
        let val = quantity;
        let val1 = Math.floor(val / 6);
        let val2 = thus.getAttribute('data-itemhandle');
        let val3 = thus.getAttribute('data-itemvariants');
        // console.log(val);
        if (val >= 0) {
          Globalobject.forEach((prd) => {

            if (val2 == prd.handle && prd.variants != null) {

              var check = true;
              let id = "";
              prd.variants.forEach(function (e) {
                if (e.sku == val3) {
                  id = e.id;
                }
              });
              $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/cart.js',
                success: function (cart) {
                  let newqty = 0;
                  cart.items.forEach(function (item) {
                    let itemvarid = item.variant_id;
                    if (itemvarid == id) {
                      check = "truee";
                      newqty = item.quantity;
                      $(".cart-item").find('.v' + id).attr('value', val1);
                      $(".cart-item").find('.v' + id).text(val1);
                    }
                  });

                  if (check == "truee") {
                    // alert('helloocartchange');
                    if (val1 > newqty || val1 < newqty) {
                      $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                          id: id,
                          quantity: val1
                        },
                        dataType: "json",
                        success: function (e) {
                          if (val1 == 0 && val <= 5) {
                            location.reload();
                          }
                          if ($(".cart-item").find('.v' + id).attr('value') == 0) {
                            location.reload();
                          }
                        }
                      });
                    }
                  }
                  else {
                    if (window.location.href.includes('cart')) {
                      // alert('helloocart');
                      $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: { id: id, quantity: val1 },
                        dataType: "json",
                        success: function (e) {
                          location.reload();
                        }
                      });
                    }
                    else {
                      // alert('helloo')
                      if (val1 >= 1) {
                        $(".product-form-input-0").attr("value", id);
                        $(".product-form-input-0 + input").attr("value", val1);
                        $(".product-form-00 button").trigger("click");
                      }
                    }

                  }
                  setTimeout(function () {
                    $.ajax({
                      type: 'GET',
                      dataType: 'json',
                      url: '/cart.js',
                      success: function (cartn) {
                        $('.cart-count-bubble span:first-child').text(cartn.item_count);
                        console.log(cartn.item_count);

                        // Clear cart operation flag after cart update completes
                        setTimeout(() => {
                          window.cartOperationInProgress = false;
                        }, 100);
                      }
                    });
                  }, 500);


                }
              });

            }
          })
        }


      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();

        // Clear cart operation flag on error as well
        window.cartOperationInProgress = false;
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  y
  forceCorrectCartIcon() {
    // Force the correct cart icon to override Upcart's changes
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      const svg = cartIconBubble.querySelector('svg');
      if (svg) {
        // Check if this is Upcart's old SVG (viewBox="0 0 40 40")
        if (svg.getAttribute('viewBox') === '0 0 40 40' || svg.classList.contains('icon-cart')) {
          // Replace with our correct cart icon
          const cartCount = cartIconBubble.querySelector('.cart-count-bubble');
          const cartCountHTML = cartCount ? cartCount.outerHTML : '';

          // Determine which icon to use based on cart count
          const itemCount = cartCount ? parseInt(cartCount.querySelector('span[aria-hidden="true"]')?.textContent || '0') : 0;
          const correctIconHTML = itemCount > 0 ?
            `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" fill="none"><g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M4.667 1.45 1.334 5.894V21.45a2.222 2.222 0 0 0 2.222 2.222H19.11a2.222 2.222 0 0 0 2.223-2.222V5.894L18 1.45H4.667ZM1.333 5.894h20"></path><path d="M15.778 10.339a4.444 4.444 0 1 1-8.889 0"></path></g><defs><clipPath id="a"><path fill="#fff" d="M.667.561H22v24H.667z"></path></clipPath></defs></svg>` :
            `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" fill="none"><g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M4.667 1.45 1.334 5.894V21.45a2.222 2.222 0 0 0 2.222 2.222H19.11a2.222 2.222 0 0 0 2.223-2.222V5.894L18 1.45H4.667ZM1.333 5.894h20"></path><path d="M15.778 10.339a4.444 4.444 0 1 1-8.889 0"></path></g><defs><clipPath id="a"><path fill="#fff" d="M.667.561H22v24H.667z"></path></clipPath></defs></svg>`;

          // Replace the SVG content
          svg.outerHTML = correctIconHTML;

          // Re-add the cart count if it existed
          if (cartCountHTML && itemCount > 0) {
            cartIconBubble.insertAdjacentHTML('beforeend', cartCountHTML);
          }
        }
      }
    }
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

// Anti-Upcart cart icon override
function setupCartIconProtection() {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble) return;

  // Create a mutation observer to watch for changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const svg = cartIconBubble.querySelector('svg');
        if (svg && (svg.getAttribute('viewBox') === '0 0 40 40' || svg.classList.contains('icon-cart'))) {
          // Upcart has modified our icon, fix it immediately
          forceCorrectCartIcon();
        }
      }
    });
  });

  // Start observing
  observer.observe(cartIconBubble, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'viewBox']
  });
}

function forceCorrectCartIcon() {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble) return;

  const svg = cartIconBubble.querySelector('svg');
  if (!svg) return;

  // Check if this is Upcart's old SVG
  if (svg.getAttribute('viewBox') === '0 0 40 40' || svg.classList.contains('icon-cart')) {
    const cartCount = cartIconBubble.querySelector('.cart-count-bubble');
    const itemCount = cartCount ? parseInt(cartCount.querySelector('span[aria-hidden="true"]')?.textContent || '0') : 0;

    // Our correct cart icon SVG
    const correctIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" fill="none"><g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M4.667 1.45 1.334 5.894V21.45a2.222 2.222 0 0 0 2.222 2.222H19.11a2.222 2.222 0 0 0 2.223-2.222V5.894L18 1.45H4.667ZM1.333 5.894h20"></path><path d="M15.778 10.339a4.444 4.444 0 1 1-8.889 0"></path></g><defs><clipPath id="a"><path fill="#fff" d="M.667.561H22v24H.667z"></path></clipPath></defs></svg>`;

    // Replace the SVG
    svg.outerHTML = correctIconHTML;
  }
}

// Setup protection when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCartIconProtection);
} else {
  setupCartIconProtection();
}

// Also run protection after a delay to catch late-loading Upcart scripts
setTimeout(setupCartIconProtection, 1000);
setTimeout(forceCorrectCartIcon, 1500);
